export default "__VITE_ASSET__2d18039d__"